import { Alert, AlertTitle, Typography } from "@mui/material";
import { useNonprofitContext } from "../../hooks/commonOrgContext";
import SubheadLink from "../Global/SubheadLink";

export default function IncompleteProfileAlertBox({ completeProfile }:{ completeProfile: boolean | undefined,  }) {
  const { npo, canAdmin } = useNonprofitContext()

  if(completeProfile) return null

  return (
    <Alert severity="warning" style={{ marginBottom: '2rem' }}>
      <AlertTitle>
        Incomplete Profile
      </AlertTitle>
      <Typography mb={2}>
        Heads up, you need to add a logo and a featured image for your profile, activities, and events to appear on Field Day.
      </Typography>
      { canAdmin() &&
        <SubheadLink to={`/nonprofits/${npo.handle}/manage/settings/profile`} size="small" direction="forward">Edit profile</SubheadLink>
      }
    </Alert>
  )
}
